import emailjs from 'emailjs-com';
import { loadRatingOptions } from '../data/mockData';

// EmailJS configuration (provided by you)
const EMAIL_CONFIG = {
  serviceId: 'service_m7m4b68',
  templateId: 'template_mmd7hds',
  publicKey: 'bgVBQRZeAw9plltXd'
};

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

// Build a rich text message containing ALL details so EmailJS templates
// using {{message}} will display everything correctly
const buildFullMessage = (configuration, pricing, customerInfo) => {
  const { trussType, material, railing, decking, addOns, length, width, subModifiers } = configuration;
  const loadRating = (() => {
    const opt = (loadRatingOptions || []).find(o => o.id === (subModifiers?.loadRating || '10k'));
    return opt ? opt.name : '10,000 lb';
  })();

  return `
BRIDGE QUOTE REQUEST
====================

Contact Information:
  Name: ${customerInfo.name}
  Email: ${customerInfo.email}
  Phone: ${customerInfo.phone || 'Not provided'}
  Company: ${customerInfo.company || 'Not provided'}

Project Details:
  ${customerInfo.projectDetails || 'No additional details provided'}

Bridge Configuration:
  Length: ${length} ft
  Width: ${width} ft
  Camber: ${configuration.camber}"
  Truss Type: ${trussType}
  Material: ${material}
  Railing: ${railing}
  Decking: ${decking}
  Add-ons: ${addOns.length > 0 ? addOns.join(', ') : 'None'}
  Load Rating: ${loadRating}

Budget Estimate: ${formatCurrency(pricing.total)}
Price Range: ${formatCurrency(pricing.priceRange.low)} - ${formatCurrency(pricing.priceRange.high)}
  `.trim();
};

export const sendQuoteRequest = async (configuration, pricing, customerInfo) => {
  const { trussType, material, railing, decking, addOns, length, width, subModifiers } = configuration;

  const fullMessage = buildFullMessage(configuration, pricing, customerInfo);

  const loadRating = (() => {
    const opt = (loadRatingOptions || []).find(o => o.id === (subModifiers?.loadRating || '10k'));
    return opt ? opt.name : '10,000 lb';
  })();

  // Send ALL data through multiple common field names so it works
  // regardless of how the EmailJS template is configured
  const templateParams = {
    // contact fields
    name: customerInfo.name,
    from_name: customerInfo.name,
    email: customerInfo.email,
    from_email: customerInfo.email,
    reply_to: customerInfo.email,
    phone: customerInfo.phone || 'Not provided',
    company: customerInfo.company || 'Not provided',

    // project details — sent under every common variable name
    project_details: customerInfo.projectDetails || 'No additional details provided',
    message: fullMessage,
    notes: customerInfo.projectDetails || 'No additional details provided',

    // config summary
    truss_type: trussType,
    material: material,
    railing: railing,
    decking: decking,
    length_label: `${length} ft`,
    width_label: `${width} ft`,
    camber_in: configuration.camber,
    load_rating: loadRating,

    // estimate
    estimated_total: formatCurrency(pricing.total),

    // recipient
    to_email: 'sales@365isi.com',
    to_name: '365 Industrial Solutions'
  };

  try {
    console.log('Sending EmailJS quote request...', { serviceId: EMAIL_CONFIG.serviceId, templateId: EMAIL_CONFIG.templateId });
    const res = await emailjs.send(
      EMAIL_CONFIG.serviceId,
      EMAIL_CONFIG.templateId,
      templateParams,
      EMAIL_CONFIG.publicKey
    );
    console.log('EmailJS response:', res);
    if (res && (res.status === 200 || res.text === 'OK')) {
      return { success: true };
    }
    return { success: false, message: `EmailJS returned status: ${res?.status}, text: ${res?.text}` };
  } catch (error) {
    console.error('EmailJS error:', error);
    return { success: false, message: error?.text || error?.message || 'Failed to send quote request via EmailJS.' };
  }
};